module.exports = __webpack_public_path__ + "static/media/GNB_05-1.82eaf220.svg";